import { render, staticRenderFns } from "./chart6.vue?vue&type=template&id=60dfdd36&scoped=true&"
import script from "./chart6.vue?vue&type=script&lang=js&"
export * from "./chart6.vue?vue&type=script&lang=js&"
import style0 from "./chart6.vue?vue&type=style&index=0&id=60dfdd36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60dfdd36",
  null
  
)

export default component.exports